import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { isClientSide, isServerSide } from "../environment-utils";
import { environment } from "../environments/environment";

@Component({
    template: `
        <app-spinner></app-spinner>
    `
})
export class BounceToAppComponent {
    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        if (isServerSide())
            return;

        if (isClientSide()) {
            let url = `${environment.urls.app}${location.pathname.replace(/^\/w\//, '/')}${location.search}`;
            setTimeout(() => {
                location.assign(url);
            }, 500)
        }
    }
}